export default __webpack_public_path__ + "static/media/4.558188f7.mp3";